import React from 'react'
import { Section, Image, Link } from 'newComponents'
import './styles.scss'

const WhatsNew = (props) => {
  const { title, content, url, image } = props

  const titleHTML = title?.html
  const contentHTML = content?.html
  const linkUrl = url?.url

  return (
    <Section>
      <div className="container">
        <div className="whats-new-container">
          <div className="whats-new-container-left">
            <h6>What's New</h6>
            {titleHTML && (
              <Link to={linkUrl}>
                <div dangerouslySetInnerHTML={{ __html: titleHTML }} className="whats-new-title" />
              </Link>
            )}
            {contentHTML && <div dangerouslySetInnerHTML={{ __html: contentHTML }} className="whats-new-content" />}
          </div>
          {image && (
            <Link className="whats-new-container-right" to={linkUrl}>
              <Image image={image} />
            </Link>
          )}
        </div>
      </div>
    </Section>
  )
}

export default WhatsNew
